var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallengeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-challenge-1514781 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.9409 16.5789L26.9867 12.6247V8.80714C26.9867 8.80288 26.9867 8.79754 26.9867 8.79327V2.39967C26.9867 1.80981 26.5099 1.33301 25.9201 1.33301H18.4534C18.0065 1.33301 17.6075 1.61141 17.4529 2.02954C17.2982 2.44874 17.4198 2.91914 17.759 3.20821L24.8534 9.29034V12.6247L15.2534 22.2247L10.6742 17.6455C10.2571 17.2285 9.58299 17.2285 9.16592 17.6455L1.69925 25.1122C1.49872 25.3117 1.38672 25.5826 1.38672 25.8663V30.133C1.38672 30.7229 1.86352 31.1997 2.45339 31.1997H30.1867C30.7766 31.1997 31.2534 30.7229 31.2534 30.133V17.333C31.2534 17.0493 31.1414 16.7783 30.9409 16.5789Z",
    fill: "url(#paint0_linear_641_123)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_123",
    x1: 16.3201,
    y1: 1.33301,
    x2: 16.3201,
    y2: 31.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeIcon);
export default __webpack_public_path__ + "static/media/challengeIcon.c2f65b9d0c5c8148fbd5cf1e8e718fe3.svg";
export { ForwardRef as ReactComponent };